import React, { useState } from "react";
import {
  StepDataGenericAccordion,
  StepItemGenericAccordion,
} from "./StepItemGenericAccordion";
import "./GenericAccordion.scss";
import { SectionHeading } from "../../Section";

interface GenericAccordionProps {
  mainTitle?: string;
  steps: StepDataGenericAccordion[];
}

export const GenericAccordion: React.FC<GenericAccordionProps> = ({
  mainTitle,
  steps,
}) => {
  const [expandedSteps, setExpandedSteps] = useState<boolean[]>(
    steps.map((_, index) => index === 0),
  );

  const toggleStep = (index: number) => {
    const updated = [...expandedSteps];
    updated[index] = !updated[index];
    setExpandedSteps(updated);
  };

  return (
    <section className="generic-accordion">
      <SectionHeading title={mainTitle} fs="4" mdFs="2" />
      <div className="steps-container">
        {steps.map((step, index) => (
          <StepItemGenericAccordion
            key={index}
            title={step.title}
            badge={step.badge}
            content={step.content}
            isOpen={expandedSteps[index]}
            onToggle={() => toggleStep(index)}
          />
        ))}
      </div>
    </section>
  );
};
